module.exports = __webpack_public_path__ + "img/moniter-02.1ecd9b52.png";